import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Sort, SortDirection } from '@angular/material/sort';

@Component({
  host: { 'class': 'fw-sort-icon' },
  selector: 'fw-sort-icon',
  styleUrls: ['./fw-sort-icon.component.scss'],
  template: `
    <mat-icon *ngIf="!isSorted" class="xs">unfold_more</mat-icon>
    <mat-icon *ngIf="isSorted && direction === 'asc'" class="xs active">sort_by_alpha</mat-icon>
    <mat-icon *ngIf="isSorted && direction !== 'asc'" class="xs active" svgIcon="sort-by-alpha-desc"></mat-icon>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FwSortIconComponent {
  @Input() field: string
  @Input() sort: Sort

  get isSorted(): boolean {
    return this.sort?.active === this.field;
  }

  get direction(): SortDirection {
    return this.sort?.direction ?? '';
  }
}
